import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft, Calendar } from "lucide-react";
import api from "../lib/api";
import { formatDate as fmt } from "../lib/date";

export default function NewsArticle() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/news/${id}`).then(({ data }) => setArticle(data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound)
    return (
      <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="news-not-found">
        <p className="text-slate-600">Article not found.</p>
        <Link to="/news" className="text-blue-600 font-semibold mt-4 inline-block">Back to news</Link>
      </div>
    );

  if (!article)
    return <div className="flex justify-center py-32"><Loader2 className="h-8 w-8 animate-spin text-[#0F2744]" /></div>;

  return (
    <article className="pb-20" data-testid="news-article-page">
      <div className="h-72 sm:h-96 overflow-hidden bg-[#0F2744]">
        <img src={article.image_url} alt={article.title} className="w-full h-full object-cover opacity-80" />
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 relative">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-8 sm:p-10">
          <Link to="/news" className="inline-flex items-center gap-1.5 text-sm text-blue-600 font-semibold mb-6" data-testid="back-to-news">
            <ArrowLeft className="h-4 w-4" /> All news
          </Link>
          <div className="flex items-center gap-2 text-sm text-slate-400 mb-3">
            <Calendar className="h-4 w-4" /> {fmt(article.created_at)} · {article.author}
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#0F2744] leading-tight">{article.title}</h1>
          <div className="mt-6 prose prose-slate max-w-none">
            {article.body.split("\n").filter(Boolean).map((para, i) => (
              <p key={i} className="text-slate-700 leading-relaxed mb-4">{para}</p>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}
